import styled from '@emotion/styled'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 15px 0 0;
  gap: 1rem;
`
